var map = {
	"./danique.jpg": "8620",
	"./eltine.jpg": "a9c6",
	"./hadassa.jpg": "cfae",
	"./jamie.jpg": "a28a",
	"./jerry.jpg": "cbdd",
	"./marion.jpg": "2d97",
	"./max.jpg": "d45a",
	"./roy.jpg": "6524",
	"./sam.jpg": "45f6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8ab8";